<app-master-data-table [data]="masterCommonService.materialsList" [columns]="materialColumns" title="Materials List"
  addButtonLabel="Material" (add)="openAddUpdateMaterialDialog('add')"
  (update)="openAddUpdateMaterialDialog('update', $event)" (delete)="deleteMaterial($event)">
</app-master-data-table>